const LANGUAGES = ["de", "en"]

function language() {
  const lang = document.documentElement.lang
  return LANGUAGES.includes(lang) ? lang : "de"
}

// `coerce-key` and `coerce-keys`: keys are rewritten in nested plain objects, and any
// other value passes through untouched. `coerce-keys` recursed into maps only; this
// port also recurses into arrays, which changes nothing for today's payloads. Every plain
// object and array is copied, because posthog-js drops an object it meets twice in one
// event: a filter set shared by `current` and `added` would reach PostHog only once.
function coerceKey(key) {
  return key
    .toLowerCase()
    .replace(/[ -]/g, "_")
    .replace(/[^a-z0-9_]/g, "")
}

function copied(value) {
  if (Array.isArray(value)) {
    return value.map(copied)
  }
  if (
    typeof value === "object" &&
    value !== null &&
    Object.getPrototypeOf(value) === Object.prototype
  ) {
    return coerceKeys(value)
  }
  return value
}

function coerceKeys(properties) {
  return Object.fromEntries(
    Object.entries(properties).map(([key, value]) => [coerceKey(key), copied(value)]),
  )
}

// `machtfit.app.tracking/capture-event!`'s payload, reproduced key for key — the
// ClojureScript side carries a comment that changes to it are coordinated with the Data
// team, so the shape here is a copy and not a design.
function capture(name, properties, uiId, eventType, options) {
  if (typeof window.posthog === "undefined") {
    return
  }
  window.posthog.capture(
    `custom_${name}`,
    {
      event: { name, ...coerceKeys(properties) },
      language: language(),
      ...(uiId ? { ui_id: uiId } : {}),
      ...(eventType ? { $event_type: eventType } : {}),
    },
    options,
  )
}

export function captureEvent(name, properties, uiId, options) {
  capture(name, properties, uiId, null, options)
}

// `machtfit.app.tracking/capture-click`.
export function captureClick(name, properties, uiId, options) {
  capture(name, properties, uiId, "click", options)
}

// For an event the page leaves right after: a batched event would wait for the
// unload flush, which a `location.href` assignment does not always reach.
export const BEFORE_NAVIGATION = { send_instantly: true, transport: "sendBeacon" }

export { coerceKey }
